import React, { useEffect, useState } from 'react'
import { Link, router, usePage } from '@inertiajs/react'

import { usePrevious } from 'react-use'
import pickBy from 'lodash/pickBy'

export default function({ title, value, clickable, link, icon: Icon, remaining }) {
    const { filters } = usePage().props

    const [values, setValues] = useState({
        card: filters?.card || ''
    })

    const prevValues = usePrevious(values)

    useEffect(() => {
        if (prevValues) {
            const query = Object.keys(pickBy(values)).length
                ? pickBy(values)
                : { remember: 'forget' }
            router.get(route(route().current(), route().params), query, {
                replace: true,
                preserveState: true
            })
        }
    }, [values])

    const Tag = link ? Link : 'div'

    return (
        <Tag
            href={link}
            className={`${clickable && 'cursor-pointer'} 'min-w-0 shadow-xs dark:bg-gray-800' overflow-hidden rounded-lg bg-white`}
            onClick={() => {
                if (clickable) {
                    setValues({
                        card: title
                    })
                }
            }}
        >
            <div className="flex items-center p-4">
                <div className="mr-4 rounded-full p-3 text-orange-500">
                    <Icon size={30} color="#6366f1" />
                </div>

                <div>
                    <p className="text-md mb-2 font-semibold text-gray-600">{title}</p>
                    <p className="text-lg font-bold text-gray-700">
                        {value}
                        {remaining && <span className="text-lg pl-2 font-bold text-green-700">({remaining})</span>}
                    </p>
                </div>
            </div>
        </Tag>
    )
}
